enum ChargebeeWebhookEventsEnum {
  SubscriptionChanged = 'subscription_changed'
}

export default ChargebeeWebhookEventsEnum;
